<template>
  <div class="mc-notification-media__item mc-notification-media__item--noitem">
    <div class="mc-notification-media__item--noitem-wrapper">
      <i class="mc-fa icon-outline_image-broken"></i>
      <p>{{ $t('global.noImage') }}</p>
    </div>
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scoped></style>
